'use client'

import { createContext, Dispatch, HTMLProps, ReactNode, ReactPortal, SetStateAction } from 'react'
import type { Placement } from '@floating-ui/react'

export const MenuContext = createContext<{
  getItemProps: (userProps?: HTMLProps<HTMLElement>) => Record<string, unknown>
  activeIndex: number | null
  setActiveIndex: Dispatch<SetStateAction<number | null>>
  setHasFocusInside: Dispatch<SetStateAction<boolean>>
  isOpen: boolean
}>({
  getItemProps: () => ({}),
  activeIndex: null,
  setActiveIndex: () => {},
  setHasFocusInside: () => {},
  isOpen: false,
})

export interface MenuProps {
  label: ReactNode | ReactPortal | string
  nested?: boolean
  placement?: Placement
  children?: ReactNode
}

export interface MenuComponentProps extends MenuProps, Omit<HTMLProps<HTMLButtonElement>, 'label'> {}
